import React, { useState } from 'react';
import styles from './edit-profile-form.module.scss';
import Input from 'components/molecules/input/input';
import Textarea from 'components/molecules/textarea/textarea';
import { TUser } from 'models/common';
import Switch from '@mui/material/Switch';
import { WTooltip } from 'components/wrappers/wrapper';
import HelpOutline from '@mui/icons-material/HelpOutline';

interface SwitchValue {
  makeEmailVisible: boolean;
  preventMessaging: boolean;
  showProfileInDirectory: boolean;
}

interface EditProfileFormProps {
  values: TUser;
  switchValues: SwitchValue;
  onInputChange: (field: string, value: string) => void;
  onSwitchToggle: (key: keyof SwitchValue) => void;
}

const EditProfileForm: React.FC<EditProfileFormProps> = ({
  values,
  switchValues,
  onInputChange,
  onSwitchToggle,
}) => {
  return (
    <div className={styles.editProfileForm}>
      <Input
        label="Full Name"
        placeholder="Full Name"
        value={values.username!}
        onChange={(e) => onInputChange('username', e.target.value)}
      />
      <Textarea
        label="Bio"
        placeholder="Tell us bit about yourself"
        value={values.biography!}
        onChange={(e) => onInputChange('biography', e.target.value)}
      />
      <Input
        label="Website"
        placeholder="Website"
        value={values.website!}
        onChange={(e) => onInputChange('website', e.target.value)}
      />
      <Input
        label="Company"
        placeholder="Company"
        value={values.company!}
        onChange={(e) => onInputChange('company', e.target.value)}
      />
      <Input
        label="Job"
        placeholder="Job"
        value={values.job!}
        onChange={(e) => onInputChange('job', e.target.value)}
      />
      <div className={styles.permissions}>
        <span className={styles.sectionTitle}>Permissions</span>
        <div className={styles.switchWrapper}>
          <Switch
            className={styles.switch}
            defaultChecked={switchValues.makeEmailVisible}
            onChange={onSwitchToggle.bind(null, 'makeEmailVisible')}
          />
          <span className={styles.text}>Make my email publicly visible</span>
          <WTooltip title="Your email will be visible in your profile" arrow>
            <HelpOutline />
          </WTooltip>
        </div>
      </div>
    </div>
  );
};

export default EditProfileForm;
